module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/12LDTp9/tc-custom/9798889103653.jpg?1705539731636",
      "alt": "This image is the cover for the book Convulsions of the Planet Earth"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Convulsions of the Planet Earth\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', {
    staticStyle: {
      "margin-top": "0cm",
      "margin-right": "0cm",
      "margin-bottom": "8.0pt",
      "margin-left": "0cm",
      "font-size": "15px",
      "font-family": "\"Calibri\",sans-serif"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "16px",
      "font-family": "\"Times New Roman\",serif"
    }
  }, [_vm._v("“The greatest mystery in the history of world aviation” – the disappearance of five American bombers in the Northwest Atlantic without a trace. What is going on in the Bermuda Triangle? What are UFOs? What is the true reason for the Chernobyl tragedy and the sinking of the Kursk submarine? Why did Soviet air defenses shoot down a South Korean passenger airliner (flight KAL-007) in the sky over Sakhalin? What is the reason for the crash of the Russian Superjet-100 in Indonesia? Where did the Malaysian Airlines Boeing 777 (flight MH-370) get lost? What unites these seemingly unrelated events?")])]), _c('p', {
    staticStyle: {
      "margin-top": "0cm",
      "margin-right": "0cm",
      "margin-bottom": "8.0pt",
      "margin-left": "0cm",
      "font-size": "15px",
      "font-family": "\"Calibri\",sans-serif"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "16px",
      "font-family": "\"Times New Roman\",serif"
    }
  }, [_vm._v("For many years, these questions have haunted the minds of both sensational journalists and scientists. So, finally, the readers will be able to come close to unraveling this dark page in the history of mankind. The hypothesis proposed by Boris Ostrovsky sheds light on questions that researchers of the unknown are trying in vain to answer.")])]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Boris Ostrovsky\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }), _c('p', {
    staticStyle: {
      "margin": "0cm",
      "font-size": "16px",
      "font-family": "Calibri, sans-serif",
      "text-align": "justify"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "14px",
      "font-family": "\"Times New Roman\",serif"
    }
  }, [_vm._v("Boris Ostrovsky (PhD in Psychiatry) was born on 20 January 1943 in Baku (Azerbaijan), graduated from Novosibirsk Medical University and at first worked in Siberia, then in one of the leading Moscow psychiatric institutions. In 1979, he emigrated to Germany, where he continued his scientific and clinical activities. For 12 years, he has been the head of the mental health department at the Red Cross Clinic in Berlin. He is the author of a number of books and articles published in Moscow. After his retirement in 2001, he moved to Israel for permanent residence.")])]), _c('p', [_c('br')]), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Austin Macauley Publishers\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0